import { render, staticRenderFns } from "./BulkEditModal.vue?vue&type=template&id=5fd42d4f"
import script from "./BulkEditModal.vue?vue&type=script&lang=ts"
export * from "./BulkEditModal.vue?vue&type=script&lang=ts"
import style0 from "./BulkEditModal.vue?vue&type=style&index=0&id=5fd42d4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports